import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-logo-header',
  styleUrls: ['./logo-header.component.scss'],
  templateUrl: './logo-header.component.html'
})
export class LogoHeaderComponent implements OnInit {

  @Input() imageUrl: string;
  @Input() headerText: string;
  @Input() contentClass: string;
  @Input() imageClass: string;
  constructor() {
    this.imageUrl = 'logo.png';
    this.headerText = 'Online Pre-Employment Testing Suite';
    this.contentClass = 'logo-text-container';
    this.imageClass = 'logo-image-container';
   }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/src/app/core/components/logo-header/logo-header.component.ts